import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { AuthService } from 'src/app/_service/auth.service';
import { MeetingsService } from 'src/app/_service/meetings.service';
import { TranslateService } from '@ngx-translate/core';

import * as routing from '../../../_model/routing';

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrl: './room.component.css'
})
export class RoomComponent {
  roomName = '';
  defaultParticipantName = '';
  token!: string;
  LIVEKIT_URL!: string;
  loading = true;
  serverError = '';

  constructor(
    public router: Router,
    private meetingsService: MeetingsService,
    private location: Location,
    private translate: TranslateService,
    private auth: AuthService,
  ) {
    this.LIVEKIT_URL = this.meetingsService.LIVEKIT_URL;
    this.roomName = this.meetingsService.roomName;
    this.defaultParticipantName = this.auth.userName;
  }

  async onTokenRequested(participantName: string) {
		try {
			const response = await this.meetingsService.getToken({roomName: this.roomName, participantName});
			this.token = response.data?.token;
		} catch (error: any) {
			console.error(error);
      this.serverError = error?.error?.message;
      window.alert(
        this.translate.instant("joinMeetingErr", {
          error: this.serverError
        })
      );
		} finally {
			this.loading = false;
		}
	}

  onRoomDisconnected() {
    this.router.navigate([routing.Calendar]);
	}

}
